<template>
<!--  新闻中心-->
  <div class="news">
    <div class="imgBox" >
      <img :src="itemData.content.boxImg.urlData" class="imgBox_img">
    </div>
    <div class="newsContent">
      <div class="contentItem">
      <div class="newsContentTatil">{{itemData.content.itemData.text1.content}}</div>
      <div class="newsContentMsg">{{itemData.content.itemData.text2.content}}</div>
      <div class="newsContentN" v-for="itemAll in itemData.content.itemData.news">
        <div class="newsContentN_item" v-for="item in itemAll" @click="toItem(item.path.content)">
          <div class="newsContentN_item_1">
            <img :src="item.img.content" class="newsContentN_item_img">

          </div>
          <div class="newsContentN_item_2">
            {{item.text1.content}}
          </div>
          <div class="newsContentN_item_3">
            {{item.text2.content}}
          </div>

        </div>
      </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Data } from './js/news.js';
export default {
  name: "news",
  data() {
    return {
      dataAll: Data,
      itemData: {},
      imageHeight: "596px",
      screenWidth: 0,
      menuIndex: "1",
      url:"http://116.62.38.250//image//nr/tp/gywm.jpg"
    }
  },
  created() {
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }


  },
  methods:{
    toItem(path){
      this.$router.push('/newsItem?path='+path);
    }
  }
}
</script>

<style scoped>
.newsContentN_item_3{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 18px;
  color: #181818;
  line-height: 26px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 8px;
  margin-left: 32px;
  margin-bottom: 32px;
}
.newsContentN_item_2{

  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 14px;
  color: #014ED5;
  line-height: 24px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 32px;
  margin-left: 32px;
}
.newsContentN_item_img{
  width: 100%;
  aspect-ratio: 360/209;
}
.newsContentN_item_1{
  width: 100%;
}
.newsContentN_item{
  width: 31.52%;
  margin-right: 20px;



}
.contentItem{
  width: 78%;
  /*display: flex;*/

}
.newsContentN{
  width: 100%;
  margin-top: 24px;
  display: flex;
}
.newsContentMsg{

  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 20px;
  color: #454545;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.newsContentTatil{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 80px;
}
.newsContent{
  display: flex;
  justify-content: center;
}
.imgBox_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.imgBox{
  width: 100%;
  padding-top: 41.39%;
  position: relative;
}
.news{
  background: #FFFFFF;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue